export enum ResourceType {
  EXT_DOWNLOAD = 'EXT_DOWNLOAD',
  EXT_URL = 'EXT_URL',
  FILE = 'FILE',
}
